@if (!isMobileView && advicedProduct.name === "Pro") {
  <div
    class="nes-flex nes-w-full nes-justify-center nes-items-center nes-mb-20"
  >
    <div class="nes-w-5/12">
      <p class="nes-text-inverse-subdued nes-uppercase nes-text-200">
        {{ "ADVICE.SYSTEM_COUPLING.HEADER_EYEBROW" | translate }}
      </p>
      <h2 class="nes-text-inverse-subdued nes-font-bold nes-text-1000 nes-mb-5">
        {{ "ADVICE.SYSTEM_COUPLING.HEADER" | translate }}
      </h2>
      <p class="nes-text-inverse-subdued">
        {{ "ADVICE.SYSTEM_COUPLING.TEXT" | translate }}
      </p>
    </div>
    <div class="nes-w-5/12">
      <img
        src="assets/images/systeem_koppeling.png"
        alt="systeemoverzicht"
        class=""
      />
    </div>
  </div>
}
